import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const RootCauseItem = styled(Flex)`
  border-color: ${theme.wild.color.nova.transparency.black[20]};
  border-style: solid;
  border-bottom-width: 1px;

  @media (max-width: 1023px) {
    &:nth-of-type(2n + 1) {
      border-right-width: 1px;
    }

    &:nth-of-type(5),
    &:nth-of-type(6) {
      border-bottom: none;
    }
  }

  @media (min-width: 1024px) {
    border-right-width: 1px;

    &:nth-of-type(5),
    &:nth-of-type(6) {
      border-right: 0;
    }

    &:nth-of-type(3),
    &:nth-of-type(4),
    &:nth-of-type(6) {
      border-bottom: none;
    }
  }

  &.mobileOrder-1 {
    order: 1;
  }
  &.mobileOrder-2 {
    order: 2;
  }
  &.mobileOrder-3 {
    order: 3;
  }
  &.mobileOrder-4 {
    order: 4;
  }
  &.mobileOrder-5 {
    order: 5;
  }
  &.mobileOrder-6 {
    order: 6;
  }

  &.desktopOrder-1 {
    @media (min-width: 1024px) {
      order: 1;
    }
  }
  &.desktopOrder-2 {
    @media (min-width: 1024px) {
      order: 2;
    }
  }
  &.desktopOrder-3 {
    @media (min-width: 1024px) {
      order: 3;
    }
  }
  &.desktopOrder-4 {
    @media (min-width: 1024px) {
      order: 4;
    }
  }
  &.desktopOrder-5 {
    @media (min-width: 1024px) {
      order: 5;
    }
  }
  &.desktopOrder-6 {
    @media (min-width: 1024px) {
      order: 6;
    }
  }
`
